import { api } from './index'

export type CampaignReportSandboxItem = {
  id: string
  title: string
  description: string
  category: string
}

export const campaignReportSandboxApi = api.injectEndpoints({
  endpoints: builder => ({
    getCampaignReportSandbox: builder.query<CampaignReportSandboxItem[], void>({
      query: () => 'looker/campaign_report_sandbox',
      providesTags: ['CampaignReportSandbox'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetCampaignReportSandboxQuery } = campaignReportSandboxApi
